const env = process.env.NEXT_PUBLIC_ENV;

// Logging Helpers
const LoggingEnabled = env !== 'production';
export const LocalLogger = LoggingEnabled ? console.log.bind(console) : () => {};
